(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["subscribe-button"] && !Shopify.designMode) return;
  try {
    class SubscribeButtonBlock extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const toggle = this.querySelector('[data-subscribe-toggle]');
      const panel = this.querySelector('[data-subscribe-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', () => {
        const willOpen = panel.hasAttribute('hidden');
        if (willOpen) {
          panel.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          panel.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  if (!customElements.get('subscribe-button-block')) {
    customElements.define('subscribe-button-block', SubscribeButtonBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
